import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

import { Flex } from '../flex';
import { ErrorOutlineIcon } from '../icons';
import { NoRowsOverlay, type NoRowsOverlayProps } from '../no-rows-overlay';

export interface ErrorStateProps extends NoRowsOverlayProps {
  fullscreen?: boolean;
}

const Wrapper = styled(Flex)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100dvh',
  width: '100%',
  backgroundColor: theme.palette.common.white,
}));

const ErrorState = forwardRef<HTMLDivElement, ErrorStateProps>((props: ErrorStateProps, ref) => {
  const { fullscreen: isFullScreen = false, icon = ErrorOutlineIcon } = props;

  if (isFullScreen) {
    return (
      <Wrapper ref={ref}>
        <NoRowsOverlay icon={icon} {...props} />
      </Wrapper>
    );
  }

  return <NoRowsOverlay ref={ref} icon={icon} {...props} />;
});

ErrorState.displayName = 'ErrorState';

export { ErrorState };
